import _ from 'lodash';
import { initDycolor, CreativePreviewScaled } from '~';
import BoxWidget from '@/components/box-widget/BoxWidget.vue';

initDycolor('campaigns', require(`${process.env.DYCOLOR_REQUIRE}./Campaigns.scss`)); // eslint-disable-line

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'box-widget': BoxWidget,
    'creative-preview-scaled': CreativePreviewScaled,
  },
  data() {
    return {
      opened: [0],
    };
  },
  computed: {
    campaigns() {
      const items = this.items;
      items.forEach((item, index) => {
        item.isOpen = _.includes(this.opened, index);
        item.date = item.start_date ? this.$t('fn.date', { timestamp: item.start_date }) : null;
      });
      return items;
    },
  },
  methods: {
    onToggle(key) {
      if (_.includes(this.opened, key)) {
        const index = this.opened.indexOf(key);
        this.opened.splice(index, 1);
      } else {
        this.opened.push(key);
      }
    },
    mapPost(post) {
      return post;
    },
    loadMore() {
      this.$emit('load');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/customer/campaigns/Campaigns.js